import styled from "styled-components";
import {RegulatoryDataDefaultBox} from "./regulatory-data.default.box";
import {baseColors} from "../../../../../themes/definitions/casino888/cis/base-colors";

export const RegulatoryDataCasino888CisBox = styled(RegulatoryDataDefaultBox)`
  background-color: ${baseColors.black};
  color: #cccccc;
`